import { Model } from 'modules/core/lib/mobx-rest'

interface IPayrollResult {
  payroll_document_id: number
  document_id: number
}

class PayrollResult extends Model<IPayrollResult> {
  static urlRoot() {
    return '/bookkeepers_management/payroll_results'
  }
}

export default PayrollResult
